'use strict'

module.exports = (compId, fieldName) => {
  return `${compId}.${fieldName}`
}



// WEBPACK FOOTER //
// ../node_modules/wix-code-automations-client/src/generateFieldName.js